/**
 * Represents different types of customer retention criteria.
 */
export enum CustomerRetentionTypeModel {
	/**
	 * Represents retention based on payment received.
	 */
	PaymentReceived = 1,
	/**
	 * Represents retention based on guaranteed rebate.
	 */
	GuaranteedRebate = 2,
	/**
	 * Represents retention based on days supply.
	 */
	DaysSupply = 3
}
